/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddMembersToSimGroupRequest} from "../model/add-members-to-sim-group-request";
import {CreateGroupRequest} from "../model/create-group-request";
import {GetGroupMembersByGroupIdsRequest} from "../model/get-group-members-by-group-ids-request";
import {GroupColor} from "../model/group-color";
import {IGroupable} from "../model/i-groupable";
import {SimGroup} from "../model/sim-group";
import {SimGroupType} from "../model/sim-group-type";

@Injectable({
    providedIn: "root",
})
export class SimGroupingService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addMembersToSimGroup(request: AddMembersToSimGroupRequest) {
        return super.post<SimGroup>(`/api/Grouping/AddMembersToSimGroup`, request);
    }

    public createSimGroup(request: CreateGroupRequest) {
        return super.post<SimGroup>(`/api/Grouping/CreateSimGroup`, request);
    }

    public deleteSimGroup(simGroupId: string) {
        return super.post<void>(`/api/Grouping/DeleteSimGroup`, {}, {simGroupId: simGroupId});
    }

    public getGroupMembersByGroupIds(request: GetGroupMembersByGroupIdsRequest) {
        return super.post<IGroupable[]>(`/api/Grouping/GetGroupMembersByGroupIds`, request);
    }

    public getSimGroupById(simGroupId: string) {
        return super.get<SimGroup>(`/api/Grouping/GetSimGroupById`, {simGroupId: simGroupId});
    }

    public getSimGroupsByIds(simGroupIds: string[]) {
        return super.get<SimGroup[]>(`/api/Grouping/GetSimGroupsByIds`, {simGroupIds: simGroupIds});
    }

    public getSimGroupsByType(simGroupType: SimGroupType) {
        return super.get<SimGroup[]>(`/api/Grouping/GetSimGroupsByType`, {simGroupType: simGroupType});
    }

    public removeMemberFromSimGroup(simGroupId: string, memberId: string) {
        return super.post<SimGroup>(`/api/Grouping/RemoveMemberFromSimGroup`, {}, {simGroupId: simGroupId, memberId: memberId});
    }

    public updateColorOfSimGroup(simGroupId: string, color: GroupColor) {
        return super.post<SimGroup>(`/api/Grouping/UpdateColorOfSimGroup`, {}, {simGroupId: simGroupId, color: color});
    }

    public updateNameOfSimGroup(simGroupId: string, name: string) {
        return super.post<SimGroup>(`/api/Grouping/UpdateNameOfSimGroup`, {}, {simGroupId: simGroupId, name: name});
    }
}